import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./Slices/cartSlice";
import chatReducer from './Slices/chatSlice'; // ✅ import chat slice

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    chat: chatReducer, // ✅ add chat reducer here

  },
});